require('./RAAssociateObjectiveSuccess.scss');

// @vendors
const React = require('react');
const PropTypes = require('prop-types');
const moment = require('moment');

// @commons
const { OKMessage } = require('commonsComponents/OKMessage');
const { OKButton } = require('components/commons/OKButton/OKButton');
const RAGoalSummary = require('../../../components/RAGoalSummary/RAGoalSummary');

// @utilities
const { FormattedText } = require('core/i18n').i18n;
const DateHelper = require('utilities/dateHelper');

// @constants
const {
    DATE_FORMAT,
    GOAL_TRACKING_URL,
} = require('../../../raConstants/index');

const RAAssociateObjectiveSuccess = props => {
    const {
        goalIcon,
        productName,
        productIcon,
        name,
        periodicity,
        goalEndOfDate,
        goalType,
        valuation,
        recurringContributionAmount,
        goalAmount,
        contributionFailure,
        portfolioId,
        children,
    } = props;

    const objectiveTrackingURL = `${GOAL_TRACKING_URL}/${portfolioId}`;
    let objectiveEndDateInfo;
    let goalSummary;

    if (
        periodicity > 0 &&
        !contributionFailure &&
        recurringContributionAmount > 0
    ) {
        const formattedDate = DateHelper.buildFormattedDate(
            moment(goalEndOfDate),
            DATE_FORMAT,
        );

        objectiveEndDateInfo = (
            <div className="ra-associate-objective-success__enddate-info">
                <OKMessage type="informative">
                    <p className="ra-associate-objective-success__enddate-text">
                        <FormattedText
                            value="raAssociateObjective-raAssociateObjective_periodicContributionEndDateInfo"
                            injectedStrings={[formattedDate]}
                        />
                    </p>
                </OKMessage>
            </div>
        );
    }

    goalSummary = (
        <div className="row">
            <div className="col-md-12">
                <div className="ra-associate-objective-success__section-gbi">
                    <RAGoalSummary
                        iconType={goalType}
                        goalName={name}
                        goalEndOfDate={goalEndOfDate}
                        investmentAmount={valuation}
                        goalAmount={goalAmount}
                        regularContributionsAmount={recurringContributionAmount}
                        periodicity={periodicity}
                        showWithoutContributionText={true}
                        contributionFailure={contributionFailure}
                        currentValuationLabel="raAssociateObjective-raAssociateObjective_goalValuationLabel"
                    />
                </div>
            </div>
        </div>
    );

    const legalTextSection = !!children && (
        <section className="ra-associate-objective-success__legal-text-container">
            {children}
        </section>
    );

    return (
        <div className="ra-associate-objective-success">
            <div className="row ra-associate-objective-success__container">
                <div className="row">
                    <div className="col-md-12 grid-view--fix-cell-separation">
                        {legalTextSection}
                        <section className="content-box content-box--shadow content-box--wealth ra-associate-objective-success__info-section">
                            <div className="ra-associate-objective-success__icon-container">
                                <div className="ra-associate-objective-success__portfolio-icon-container">
                                    <div className={productIcon} />
                                </div>
                                <div className="ra-associate-objective-success__content-block-arrow">
                                    <i className="ra-associate-objective-success__content-block-icon icon-flecha-izquierda" />
                                </div>
                                <div className="ra-associate-objective-success__objective-icon-container">
                                    <img
                                        className="ra-associate-objective-success__objective-icon no-print-out"
                                        src={goalIcon}
                                        alt=""
                                        aria-hidden
                                    />
                                </div>
                            </div>
                            <div className="ra-associate-objective-success__info-content">
                                <div className="ra-associate-objective-success__info-content-header">
                                    <FormattedText
                                        value="raAssociateObjective-raAssociateObjective_associatedObjectiveDetailsText"
                                        injectedStrings={[productName, name]}
                                    />
                                </div>
                                <div className="ra-associate-objective-success__info-content-text">
                                    <FormattedText value="raAssociateObjective-raAssociateObjective_associateObjectiveSuccessBody" />
                                </div>
                            </div>
                            {objectiveEndDateInfo}
                        </section>
                    </div>
                </div>
                {goalSummary}
                <div className="row">
                    <div className="col-md-12 ra-associate-objective-success__disclaimer-container">
                        <OKMessage type="informative" modifier="dark-bg">
                            <p className="ra-associate-objective-success__disclaimer-header">
                                <FormattedText value="raAssociateObjective-raAssociateObjective_assocaiteObjectiveInfoText" />
                            </p>
                        </OKMessage>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-12">
                        <div className="ra-associate-objective-success__ctabutton-container">
                            <OKButton
                                to={objectiveTrackingURL}
                                modifier="secondary"
                            >
                                <FormattedText value="raAssociateObjective-raAssociateObjective_objectiveTrackingLinkText" />
                            </OKButton>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

RAAssociateObjectiveSuccess.propTypes = {
    children: PropTypes.object,
    goalIcon: PropTypes.string.isRequired,
    productName: PropTypes.string.isRequired,
    productIcon: PropTypes.string.isRequired,
    goalType: PropTypes.string.isRequired,
    periodicity: PropTypes.bool,
    goalEndOfDate: PropTypes.string,
    name: PropTypes.string.isRequired,
    valuation: PropTypes.number,
    recurringContributionAmount: PropTypes.number,
    goalAmount: PropTypes.number.isRequired,
    contributionFailure: PropTypes.bool,
    portfolioId: PropTypes.string.isRequired,
};

RAAssociateObjectiveSuccess.defaultProps = {
    periodicity: false,
    goalEndOfDate: '',
};

module.exports = RAAssociateObjectiveSuccess;
